<template>
  <div>
    
    <v-menu transition="slide-y-transition" rounded offset-y> 
      <template v-slot:activator="{ on }">
        <v-list-item two-line v-on="on" class="pa-0 px-1">

          <!-- <v-avatar color="primary" size="48" v-if="!profile.image">
            <span class="white--text text-h5">{{ initials }}</span>
          </v-avatar>
          <v-avatar v-if="profile.image" class="pa-0">
            <img :src="profile.image" :alt="profile.name" >
          </v-avatar> -->

          <v-avatar class="ma-3" :color="profile_avatar? '' :'secondary'" size="36">
            <!-- <v-icon v-if="!profile_avatar" large dark>mdi-account</v-icon> -->
            <span v-if="!profile_avatar" class="white--text text-h5">{{ initials }}</span>
            <v-img v-if="profile_avatar" :src="profile_avatar" class="my-3" />
          </v-avatar>
            
          <v-list-item-content v-if="!$vuetify.breakpoint.mobile" class="ml-3">
            <v-list-item-title class="subtitle-2 font-weight-bold pa-0">{{profile.name}}</v-list-item-title>
            <!-- <v-list-item-subtitle class="cyan--text subtitle-2 pa-0">{{active_company.name}}</v-list-item-subtitle>-->
          </v-list-item-content>

        </v-list-item>
      </template>
      
      <v-card>
        <v-list-item-content class="justify-center" style="max-height: 100%">
          <div class="mx-auto text-center">

            <v-avatar class="ma-3" :color="profile_avatar? '' :'secondary'" size="98" v-if="!$vuetify.breakpoint.mobile">
              <!-- <v-icon v-if="!profile_avatar" large dark>mdi-account</v-icon> -->
              <span v-if="!profile_avatar" class="white--text text-h5">{{ initials }}</span>
              <v-img v-if="profile_avatar" :src="profile_avatar" class="my-3" />
            </v-avatar>

            <div class="title pt-2 px-2">{{ profile.name }}</div>

            <div class="text-caption mt-1">
              {{ profile.email }}
            </div>
            <v-divider class="my-3"></v-divider>
            <span class="text-caption" v-if="companies.length">
              Empresas:
            </span>
            <div class="companies_menu">
              <div v-for="company in companies" :key="company.id" >
                <v-btn block depressed text @click="selectCompany(company)" :color="active_company.id == company.id? 'primary' : ''">
                  {{ company.name }}
                </v-btn>
              </div>
            </div>
            <template v-if="is_super_admin">
              <v-divider class="my-3"></v-divider>
              <v-icon color="primary" small v-if="$route.name == 'CreateCompany'">mdi-arrow-right</v-icon>
              <v-btn v-if="is_super_admin" block depressed text @click="$route.name != 'CreateCompany' ? $router.push({name: 'CreateCompany'}) : ''">
                Criar empresa
              </v-btn>
            </template>
            <v-divider class="my-3"></v-divider>
            <v-icon color="primary" small v-if="$route.name == 'Account'">mdi-arrow-right</v-icon>
            <v-btn block depressed text @click="$route.name != 'Account' ? $router.push({name: 'Account'}) : ''">
              Minha conta
            </v-btn>
            <v-divider class="my-3"></v-divider>
            <v-btn block depressed text @click="goToSuporte()">
              Suporte
            </v-btn>
            <v-divider class="my-3"></v-divider>
            <v-btn block depressed text @click="$router.push({name: 'Logout'})">
              Sair
            </v-btn>
          </div>
        </v-list-item-content>
      </v-card>
    </v-menu>

  </div>
</template>

<script>
import Api from '@/api'
import { mapState, mapActions } from 'vuex';

export default {
  data: () => ({
    user: {
      full_name: 'Thiago Mesquita',
      initials: '',
      email: 'thiago.mesquita@teste.com',
      company: 'VOLLAZ',
      avatar_image: 'https://cdn.vuetifyjs.com/images/john.jpg',
      //avatar_image: '',
    },
    companies: [],
    active_company: {}
  }),

  methods: {
    goToSuporte(){
      window.open('https://www.4artz.com/suporte', '_blank')
    },
    setupCompany(){
      const local = localStorage.getItem('company_id')
      const local_tk = localStorage.getItem('company_tk')
      if (local != this.active_company.id && this.companies[0]){
        this.active_company.id = Number(local)
        this.active_company = this.companies.find(c=> c.id == Number(local))
      } else if(!local && this.companies[0]){
        this.selectCompany(this.companies[0])
        // this.active_company = this.companies.find(c=> c.id == Number(local))
      }
      if (local_tk != this.active_company.company_token){
        this.active_company.company_token = local_tk
      }
    },
    selectCompany(comp){
      this.active_company = {...comp}
      if(this.$route.name == 'ShowEvent'){
        this.$router.push({name: 'Home'})
      }
    },
    getCompanies(){
      Api.Company.index().then(r=>r.data).then(d=>{
        this.companies = [...d]
        this.setupCompany()
        // this.loading = false
      })
    },
    ...mapActions({
      setActiveCompanyId: 'App/setActiveCompanyId',
      setActiveCompanyTk: 'App/setActiveCompanyTk',
    })
  },
  computed: {
    initials() {
      return this.profile.name.match(/(^\S\S?|\s\S)?/g).map(v=>v.trim()).join("").match(/(^\S|\S$)?/g).join("").toLocaleUpperCase()
    },
    profile_avatar(){
      let img = null;
      if(this.profile && this.profile.avatar_url){
        img = this.profile.avatar_url
      }

      return img;
    },
    is_super_admin(){
      let is = false
      if (this.profile){
        is = this.profile.my_roles.some(role=> role.name == 'super_admin')
      }
      return is
    },
    ...mapState({
      profile: state => state.User.user,
      activeCompanyId: state => state.App.activeCompanyId
    }),
  },

  mounted () {
    // this.name();
    this.getCompanies();
  },
  watch: {
    'active_company.id'(nv,ov) {
      if (nv){
        this.setActiveCompanyId(nv)
        this.setActiveCompanyTk(this.active_company.company_token)
        this.$emit('companyChanged', nv)
      } else if (nv == false){
      }
    },
    activeCompanyId(nv,ov){
      this.getCompanies()
    },
    'active_company.company_tk'(nv,ov) {
      if (nv){
        // this.setActiveCompanyId(nv)
        // this.setActiveCompanyTk(nv)
        // this.$emit('companyChanged', nv)
      } else if (nv == false){
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.companies_menu{
  overflow-x: hidden !important;
  overflow-y: auto !important;
  max-height: 25vh !important;
  max-height: 200px !important;
}

</style>